<template>
	<div>
		<div v-if="loading">
		</div>
		<div v-else>
			<vx-card title="Verzendopties">
				<label>Op deze pagina kun je aangeven welke verzendopties zichtbaar zijn onder de "verzenden" knop op het bestellingen
					overzicht.</label><br /><br />
				<div class="w-full vx-row">
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['BRIEFPOST']">Briefpost</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['UPS']">UPS</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['TNT']">PostNL</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['TNT_EXTRA']">PostNL extra@home</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['TNT_BRIEF']">PostNL Briefpost</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['TNT_EXPRESS']">TNT Express</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['DYL']">Dynalogic</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['DPD_NL']">DPD Nederland</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['DPD_BE']">DPD België</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['BPOST_BE']">Bpost België</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['BPOST_BRIEF']">Bpost Briefpost</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['DHLFORYOU']">DHLFORYOU</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['GLS']">GLS</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['FEDEX_NL']">FedEx Nederland</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['FEDEX_BE']">FedEx Belgie</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['OTHER']">Anders</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['DHL']">DHL</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['DHL_DE']">DHL Germany</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['DHL_GLOBAL_MAIL']">DHL Global mail</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['TSN']">Transportservice Nederland</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['FIEGE']">Fiege</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['TRANSMISSION']">TransMission</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['PARCEL_NL']">Parcel.nl</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['LOGOIX']">LogoiX</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['PACKS']">Packs</vx-checkbox>
					</div>
					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['COURIER']">Bezorgafspraak</vx-checkbox>
					</div>

					<div class="vx-col w-full sm:w-1/2 lg:w-1/3">
						<vx-checkbox v-model="selectedSendOptions['RJP']">NedWRK(Red je pakketje)</vx-checkbox>
					</div>
					<div class="vx-col w-full pt-5">
						<vx-button @click.native="update" class="btn-submit" color="primary" type="border">Verzendopties opslaan
						</vx-button>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import VxButton from '@/components/vx-button/VxButton';
import VxCheckbox from '@/components/vx-checkbox/VxCheckbox';

export default {
	name: 'settings-shipment',
	components: {
		VxCheckbox,
		VxButton
	},
	data() {
		return {
			loading: true,
			selectedSendOptions: {},
		}
	},
	mounted() {
		this.openLoading()
	},
	methods: {
		openLoading() {
			this.$vs.loading();
			this.$store.dispatch('sendOptions/init').then(response => {
				this.selectedSendOptions = {...this.$store.state.sendOptions.deliveryOptions};
				this.$vs.loading.close();
				this.loading = false;
			})
		},
		update() {
			this.$store.dispatch('sendOptions/updateShippingoptions', this.selectedSendOptions).then(res => {
				this.createnotifySucces();
			}).catch(err => {
				this.createnotifyFailed();
			})
		},
		createnotifySucces() {
			this.$vs.notify({
				color: 'success',
				title: 'Wijzigingen zijn opgeslagen',
				text: 'Je gegevens zijn verwerkt.',
			})
		},
		createnotifyFailed() {
			this.$vs.notify({
				color: 'danger',
				title: 'Gegevens zijn niet opgeslagen',
				text: 'Er is iets fout gegaan.',
			})
		}
	}
}
</script>
<style scoped>
.btn-submit {
	width: 100%;
}
</style>
